import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { NavBar } from "./components/NavBar";
import { Banner } from "./components/Banner";
import { Skills } from "./components/Skills";
import { Projects } from "./components/Projects";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import ParticleBg from "./components/ParticleBg";
import { About } from "./components/About/About";
import { Experience } from "./components/Experience/Experience";

function App() {
  return (
    <div className="App">
      <ParticleBg />
      <NavBar />
      <Banner />
      <About />
      {/* <Skills /> */}
      <Experience />
      <Projects />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
